<template>
  <q-expansion-item
    expand-separator
    icon="mdi-clock-time-eight-outline"
    class="q-pt-md"
    expand-icon-class="text-white"
    :default-opened="$q.platform.is.desktop"
    :label="$t('catering.form.deliveryTime')"
    header-class="text-white text-weight-bolder text-uppercase bg-black"
  >
    <q-time
      v-model="time"
      :locale="locale"
      format24h
      landscape
      text-color="white"
      class="full-width"
      :options="timeOptions"
    />
  </q-expansion-item>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { constants } from 'quasar-pilot-core/src/lib/constants';

export default {
  name: 'CateringTimepicker',

  data() {
    return {
      time: '',
      locale: constants.DATE_LOCALE_OPTIONS,
    };
  },

  computed: {
    ...mapState('order', ['orderDate']),
  },

  watch: {
    time() {
      const [hours, minutes] = this.time.split(':');
      const d = new Date(this.orderDate);
      d.setHours(hours);
      d.setMinutes(minutes);
      this.updateOrderDate({ date: d });
    },
  },

  created() {
    this.time = this.orderTime ?? '';
  },

  methods: {
    ...mapMutations('order', ['updateOrderDate']),

    timeOptions(hr, min) {
      const [startHours, startMinutes] = constants.CATERING_READY_TIME_START.split(':').map((v) => {
        return parseInt(v, 10)
      });
      const [endHours, endMinutes] = constants.CATERING_READY_TIME_END.split(':').map((v) => {
        return parseInt(v, 10)
      });

      if (hr < startHours || hr > endHours) {
        return false;
      }
      if (min !== null) {
        if (hr === startHours && min < startMinutes) {
          return false;
        }
        return !(hr === endHours && min > endMinutes);
      }

      return true;
    },
  },
};
</script>
